module.exports = __webpack_public_path__ + "img/3.a8bc6736.png";